
<template>
  <section class="wrapper">
    <section class="small-section">
      <h3>Select Tax Year</h3>
      <div class="field left">
        <chc-input v-model="year" :error="errors.year" label="Year" format="combo"
                 :autoCompleteValues="$store.state.constants.irs_years" @combo-select="pullYearData" :disabled="isLoading"></chc-input>
      </div>
    </section>

    <section class="small-section" v-if="isLoading">
      <span>Loading selected year's data...</span>
    </section>
    <section class="small-section" v-if="!isLoading && year && available_count === 0">
      <span class="error-message">There are currently no available donations to add to a new file.</span>
    </section>
    <section class="small-section" v-if="!isLoading && year && available_count === 0">
      <span class="error-message">Any donations that are missing information and cannot be added to a file are listed below.</span>
    </section>
    <section class="small-section" v-if="!isLoading && year && available_count === 0">
      <span class="error-message">Any completed donations have been added to previously generated files that can be downloaded below if available.</span>
    </section>

    <section id="include-section" class="small-section" v-if="!isLoading && year && available_count !== 0">
      <input type="submit" @click="generateReport" class="btn" :value="buttonText" :disabled="isLoading || is_generating">
    </section>

    <section class="small-section" v-if="hasErrors">
      <h3>Current Issues with {{year}} Donations</h3>
      <span><strong>The following donations were towed in {{year}} but are unable to be added to the file at this time for the following reasons:</strong></span>
    </section>
    <section v-if="hasErrors" class="issues-section">
      <section class="small-section" v-if="hasErrors && errorRefs.missing_sales_price">
        <h4 class="error-message">Missing Sales Price Information</h4>
        <div v-for="(data, index) in errorRefs.missing_sales_price" v-bind:key="index">
          <dl class="data-sent">
            <dd class="data-content">{{data.ref}}</dd>
            <dd class="data-content"><router-link :to="{name: 'Vehicle', params: {vehicleId: data.id}}">Go To Vehicle Information</router-link></dd>
          </dl>
        </div>
        <!-- <span v-for="(num, index) in errorRefs" v-bind:key="index">{{num}}, </span> -->
      </section>
      <section class="small-section" v-if="hasErrors && errorRefs.missing_donor_info">
        <h4 class="error-message">Missing Valid Donor Address Information</h4>
        <div v-for="(data, index) in errorRefs.missing_donor_info" v-bind:key="index">
          <dl class="data-sent">
            <dd class="data-content">{{data.ref}}</dd>
            <dd class="data-content"><router-link :to="{name: 'Vehicle', params: {vehicleId: data.id}}">Go To Vehicle Information</router-link></dd>
          </dl>
        </div>
      </section>
      <section class="small-section" v-if="hasErrors && errorRefs.missing_charity_info">
        <h4 class="error-message">Associated Charity Missing Either a Valid Tax Id or a Valid Address</h4>
        <div v-for="(data, index) in errorRefs.missing_charity_info" v-bind:key="index">
          <dl class="data-sent">
            <dd class="data-content">{{data.ref}}</dd>
            <dd class="data-content"><router-link :to="{name: 'Charity', params: {charityId: data.charity_id}}">Go To {{data.charity_name}} Information</router-link></dd>
          </dl>
        </div>
      </section>
    </section>

    <section class="small-section" v-if="previousReports.length > 0">
      <h3>Previously Generated Reports for {{year}}</h3>
      <span>Click to download</span>
      <div class="field left" v-for="report in previousReports" v-bind:key="report.id">
        <a :id="report.id" @click="downloadReport(report.id,report.name, report.year)">{{report.name}} {{report.vehicle_count}} Vehicles</a>
      </div>
    </section>
  </section>
</template>

<script>
import store from '@/store'
import helpers from '@/helpers'

export default {
  name: 'IrsReports',
  props: {
  },
  data () {
    return {
      year: null,
      previousReports: [],
      errors: {},
      isLoading: false,
      is_generating: false,
      available_count: null,
      hasErrors: false,
      errorRefs: {
        missing_donor_info: null,
        missing_sales_price: null,
        missing_charity_info: null,
      },
    }
  },
  computed: {
    buttonText () {
      if (this.is_generating) return 'Generating...'
      if (this.available_count !== 0) return 'Generate IRS Report for ' + this.available_count + ' Vehicles'
      return 'No available vehicles'
    }
  },
  methods: {
    generateReport () {
      this.is_generating = true
      store.functions.reports.generateIrsReport({year: this.year}, (refs) => {
        this.hasErrors = true
        this.is_generating = false
      }).then((response) => {
        this.previousReports.unshift(response.data)
        this.downloadReport(response.data.id, response.data.name, response.data.year)
        this.is_generating = false
        this.available_count = 0
      }).catch(error => {
        console.log(error)
        this.is_generating = false
      })
    },
    pullYearData (year) {
      if (this.year === year) return
      this.previousReports = []
      this.hasErrors = false
      this.errorRefs = []
      this.isLoading = true
      store.functions.reports.fetchIrsYearData(year, (response) => {
        this.previousReports = response.data.generated_reports
        this.hasErrors = response.data.invalid_records.invalid
        this.errorRefs = response.data.invalid_records.errors
        this.available_count = response.data.available_count
        this.isLoading = false
      })
    },
    downloadReport (id, date, year) {
      store.functions.reports.downloadIrsReport({id: id}, (error) => {
        console.log(error)
        // error handling
      }).then((response) => {
        helpers.openAsDownload(response.data, year + '_report_' + date)
      })
    },

    routeToVehicle (id) {

    },
    routeToCharity (id) {

    },
  },
  components: {
  }
}
</script>

<style scoped lang="scss">
  .issues-section {
    display: flex;
  }
</style>



// WEBPACK FOOTER //
// src/components/Reports/IrsReports.vue